import dayjs from "dayjs";
import type { DateRangePreset, DateRangeValue } from "../components/DateRangeHeader";
import { defaultLast7Days } from "../components/DateRangeHeader";
import type { DashboardDefaults } from "../types/dashboard";

const IST = "Europe/Istanbul";

function toIso(d: dayjs.Dayjs): string {
  return d.toDate().toISOString();
}

export function presetFromDashboardDefaults(defaults?: DashboardDefaults): DateRangePreset {
  const key = defaults?.defaultDateRange || "last_7d";
  if (key === "last_30d") return "last30";
  if (key === "this_month") return "thisMonth";
  return "last7";
}

export function rangeFromDashboardDefaults(defaults?: DashboardDefaults): DateRangeValue {
  const key = defaults?.defaultDateRange || "last_7d";
  const now = dayjs();
  if (key === "last_30d") {
    return { from: toIso(now.subtract(30, "day")), to: toIso(now) };
  }
  if (key === "this_month") {
    return { from: toIso(now.startOf("month")), to: toIso(now) };
  }
  return defaultLast7Days();
}

export function dashboardTimezone(defaults?: DashboardDefaults): string {
  return defaults?.timezone || IST;
}
